export default __webpack_public_path__ + "static/media/blue-shape.1af317e9.png";